import PropTypes from "prop-types";
import React from "react";
import RadioType from "../display-types/radio";
import TextType from "../display-types/text";
import NumberWithUnit from "../display-types/number-with-unit";
import CheckboxType from "../display-types/checkbox";
import HourMinuteType from "../display-types/hour-minute";
import BodyPartSelection from "../display-types/body-part-selection";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const DietFigure = ({ food, caption }) =>
  <div className="cxa-grid__item cxa-grid__item--two">
    <figure className="cxa-questionnaire__figure">
      <img src={`/assets/images/wellness/diet_info_${food}.png`} alt="" />
      <figcaption>
        {caption}
      </figcaption>
    </figure>
  </div>;

DietFigure.propTypes = {
  food: PropTypes.string,
  caption: PropTypes.string,
};

const NoGroupingLayout = ({
  subsection,
  primaryQuestion,
  selectedLanguage,
  ...props
}) =>
  <section>
    <h2>
      {subsection.subsectionName &&
        <FormattedMessage
          id={subsection.subsectionName}
          defaultMessage={subsection.subsectionName}
        />}
    </h2>

    {subsection.subsectionTag === "physical_activity_q" &&
      <div className="cxa-grid__wrapper">
        <div className="cxa-grid__item cxa-grid__item--six">
          <figure>
            <img
              alt=""
              src="/assets/images/wellness/activity_info_moderate.png"
            />
            <figcaption>
              <strong>
                <FormattedMessage {...messages.moderateExerciseDescription} />:
              </strong>{" "}
              <FormattedMessage {...messages.moderateActivityDescription} />
            </figcaption>
          </figure>
        </div>
        <div className="cxa-grid__item cxa-grid__item--six">
          <figure>
            <img
              alt=""
              src="/assets/images/wellness/activity_info_vigorous.png"
            />
            <figcaption>
              <strong>
                <FormattedMessage {...messages.vigorousExerciseDescription} />:
              </strong>{" "}
              <FormattedMessage {...messages.vigorousActivityDescription} />
            </figcaption>
          </figure>
        </div>
      </div>}

    {subsection.subsectionTag === "diet_text_input" &&
      <div>
        <p>
          <FormattedMessage {...messages.titleRepresentServingDescription} />
        </p>
        <div className="cxa-grid__wrapper">
          <DietFigure
            food="broccoli"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionBroccoli} />
            }
          />
          <DietFigure
            food="carrots"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionCarrots} />
            }
          />
          <DietFigure
            food="capsicum"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionCapsicum} />
            }
          />
          <DietFigure
            food="vegetables"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionVegetables} />
            }
          />
          <DietFigure
            food="salad"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionSalad} />
            }
          />
          <DietFigure
            food="sugar"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionSugar} />
            }
          />
          <DietFigure
            food="cake"
            caption={<FormattedMessage {...messages.dietInfoDescriptionCake} />}
          />
          <DietFigure
            food="apple"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionApple} />
            }
          />
          <DietFigure
            food="banana"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionBanana} />
            }
          />
          <DietFigure
            food="orange"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionOrange} />
            }
          />
          <DietFigure
            food="pear"
            caption={<FormattedMessage {...messages.dietInfoDescriptionPear} />}
          />
          <DietFigure
            food="fruit"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionFruit} />
            }
          />
          <DietFigure
            food="soda"
            caption={<FormattedMessage {...messages.dietInfoDescriptionSoda} />}
          />
          <DietFigure
            food="chocolate"
            caption={
              <FormattedMessage {...messages.dietInfoDescriptionChocolate} />
            }
          />
        </div>
        <h3>
          <FormattedMessage {...messages.foodConsumeDescription} />
        </h3>
      </div>}

    {subsection.questions.map(q => {
      if (!q) {
        return null;
      }
      if (
        q.visibility &&
        JSON.parse(q.visibility).QuestionTag === "smoking_profile" &&
        primaryQuestion !== "1"
      ) {
        return null;
      }

      if (
        q.visibility &&
        JSON.parse(q.visibility).QuestionTag === "alcohol_profile" &&
        primaryQuestion !== "116"
      ) {
        return null;
      }

      switch (q.displayType) {
        case "radio":
          return (
            <RadioType
              key={q.tag}
              question={q}
              selectedLanguage={selectedLanguage}
            />
          );
        case "slider":
          return (
            <RadioType
              key={q.tag}
              question={q}
              selectedLanguage={selectedLanguage}
            />
          );
        case "text":
          if (q.units) {
            return <NumberWithUnit key={q.tag} question={q} />;
          }
          return <TextType key={q.tag} question={q} />;
        case "checkbox":
          return <CheckboxType key={q.tag} question={q} />;
        case "hour_minute":
          return <HourMinuteType key={q.tag} question={q} />;
        case "custom":
          return <BodyPartSelection key={q.tag} question={q} {...props} />;
        default:
          return null;
      }
    })}
  </section>;

NoGroupingLayout.propTypes = {
  subsection: PropTypes.object,
  primaryQuestion: PropTypes.string,
  selectedLanguage: PropTypes.object,
};

export default NoGroupingLayout;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/layouts/no-grouping.jsx